module.exports = __webpack_public_path__ + "static/media/footer_line.47d384bd.svg";